/**
 * The vendor's booking settings: zCRM's defaults (bookingConfig.ts) until someone edits them on
 * the settings screen. Edits are kept in this browser's zCRM store, because zInspector has no
 * vendor-settings write yet; anything that no longer validates falls back to the defaults.
 */
import { useStore } from "ra-core";
import { useMemo } from "react";

import {
  BOOKING_SETTINGS_STORE_KEY,
  bookingSettingsSchema,
  DEFAULT_BOOKING_SETTINGS,
  type BookingSettings,
} from "../providers/zinspector/bookingConfig";

export const useBookingSettings = () => {
  const [stored, setStored] = useStore<BookingSettings | null>(
    BOOKING_SETTINGS_STORE_KEY,
    null,
  );
  const settings = useMemo(() => {
    const parsed = bookingSettingsSchema.safeParse(stored);
    return parsed.success ? parsed.data : DEFAULT_BOOKING_SETTINGS;
  }, [stored]);
  return {
    settings,
    isCustomized: stored != null && settings !== DEFAULT_BOOKING_SETTINGS,
    save: (next: BookingSettings) => setStored(next),
    reset: () => setStored(null),
  };
};
